import { HttpInterceptorFn } from '@angular/common/http';
import { LoaderService } from '../../shared/services/loader.service';
import { inject } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';

export const httpInterceptor: HttpInterceptorFn = (req, next) => {
  const cookieService = inject(CookieService);
  const loaderService = inject(LoaderService);

  const token = cookieService.get('token');

  
  if(req.url.includes('auth')) {
    return next(req);
  }
  
  if (token) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  loaderService.show();
  return next(req).pipe(
    finalize(() =>  loaderService.hide())
  );
};
